module.exports = __webpack_public_path__ + "img/main_architecture_image01.3a242d91.jpg";